import React, { useMemo, useState, useEffect } from "react";
import { Document } from "../types/Document";
import "../styles/DocumentListeAgentPage.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import AddDocumentMenuWrapper from "../components/AddDocumentMenuWrapper";
import { useNavigate } from "react-router-dom";
import CollecteLoadingMessage from "../components/CollecteLoadingMessage";
import AuthentifiedPage from "./AuthentifiedPage";
import { Domaine, SousDomaine, SousSousDomaine } from "../types/Domaine";
import { useAuth } from "../context/AuthContext";
import { Indicateur } from "../types/Indicateur";
import { GroupeImportService } from "../services/GroupeImportService";
import { DocumentStatus, StatusBadge } from "../constants/DocStatus";
import DynamicTable from "../components/DynamicTable";

const DocumentListeAgentPage: React.FC = () => {
  const navigate = useNavigate();
  const { user,api  } = useAuth();
  const [query, setQuery] = useState("");
  const [statutFilter, setStatutFilter] = useState<string>("");
  const [domaineFilter, setDomaineFilter] = useState<string>("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState<number>(10);
  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState<any[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState<any[]>([]);
  const [buttonClicked, setButtonClicked] = useState<"import" | "manual" | "createForm" | "createIndicator"| "createRapport"| null>(null);
  const [indicateurs, setIndicateurs] = useState<Indicateur[]>([]);
  
  const getIndicatorsForTable = (tableName: string) => {
  const saved = localStorage.getItem("indicateurs");
  if (!saved) return [];

  const all: Indicateur[] = JSON.parse(saved);
  return all.filter((ind: Indicateur) => ind.tableName === tableName);
};


  useEffect(() => {
    GroupeImportService.getAll(api).then((value)=>{
      const docs:any[]=[];

      value.forEach((groupImport)=>{
        const nomFenetre = groupImport.fenetre.nomFenetre;
        const nomSousFenetre = groupImport.sousFenetre?.nomSousFenetre;

        docs.push({
          id: groupImport.idGroupeImport,
          domaine: groupImport.fenetre.menu.nomMenu,
          contenu: nomSousFenetre
            ? `${nomFenetre} - ${nomSousFenetre}`
            : nomFenetre,
          date: new Date(groupImport.dateImport).toLocaleDateString(),
          statut: groupImport.status as DocumentStatus
        });
      })

      setDocuments(docs);
    });
  }, []);



  const filtered = useMemo(() => {
    let list = documents.slice();

    if (query) {
      const q = query.toLowerCase();
      list = list.filter(
        (d) =>
          d.contenu.toLowerCase().includes(q) ||
          d.domaine.toLowerCase().includes(q)
      );
    }

    if (statutFilter) list = list.filter((d) => d.statut === statutFilter);

    if (domaineFilter) {
      list = list.filter(
        (d) =>
          d.fenetre.toLowerCase().includes(domaineFilter.toLowerCase()) ||
          d.sousFenetre.toLowerCase().includes(domaineFilter.toLowerCase())
      );
    }

    return list;
  }, [documents, query, statutFilter, domaineFilter]);

  const total = filtered.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageData = filtered.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleSelectDomain = (domain: Domaine, sousDomain?: SousDomaine, sousSousDomain?: SousSousDomaine) => {
    setShowMenu(false);

    setLoading(true);
    setTimeout(() => {
      setLoading(false);

      navigate("/agent/collect", {
        state: {
          domain,
          sousDomain,
          sousSousDomain,
          mode: buttonClicked,
        },
      });
    }, 500);
  };

  const handleCreateForm = (domain: Domaine, sousDomain?: SousDomaine, sousSousDomain?: SousSousDomaine) => {
    domain.icon=undefined;
    setShowMenu(false);
    setLoading(true);

    setTimeout(() => {
      setLoading(false);

      navigate("/admin/dynamic-form", {
        state: {
          domain,
          sousDomain,
          sousSousDomain,
          mode: "createForm",
        },
      });
    }, 500);
  };

  const handleCreateRapport = (domain: Domaine, sousDomain?: SousDomaine, sousSousDomain?: SousSousDomaine) => {
    domain.icon = undefined;
    setShowMenu(false);
    setLoading(true);

    const tableName =
      sousSousDomain?.label ||
      sousDomain?.label ||
      domain?.label;

    const relatedIndicators = getIndicatorsForTable(tableName);

    setTimeout(() => {
      setLoading(false);

      navigate("/create-rapport", {
        state: {
          domain,
          sousDomain,
          sousSousDomain,
          mode: "createRapport",
          tableName,
          indicators: relatedIndicators 
        },
      });
    }, 500);
  };

  const handleCreateIndicator = (domain: Domaine, sousDomain?: SousDomaine, sousSousDomain?: SousSousDomaine) => {
    domain.icon = undefined;
    setShowMenu(false);
    setLoading(true);

    setTimeout(() => {
      setLoading(false);

      navigate("/create-indicateur", {
        state: {
          domain,
          sousDomain,
          sousSousDomain,
          mode: "createIndicator",
        },
      });
    }, 500);
  };

  return (
    <AuthentifiedPage>
      <main className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h4 className="text-success fw-bold mb-0">Liste des documents </h4>          
          <div className="button-group">             
            {(user?.roleRank ?? 0) >= 2 && (
              <button
                className="btn-import"
                onClick={() => {
                  setButtonClicked("createRapport");
                  setShowMenu(true);
                }}
              >
                <i className="bi bi-file-earmark-text"></i>Créer un rapport
              </button>
            )}
            {(user?.roleRank??0)>= 2 && (
              <button
                className="btn-import"
                onClick={() => {
                  setButtonClicked("createForm");
                  setShowMenu(true);
                }}
              >
                <i className="bi-ui-checks"></i>Créer un formulaire
              </button>
            )}
            {(user?.roleRank??0) >= 2 && (
              <button
                className="btn-import"
                onClick={() => {
                  setButtonClicked("createIndicator");
                  setShowMenu(true);
                }}
              >
                <i className="bi bi-bar-chart-line"></i>Créer un indicateur
              </button>
            )}
            <button
              className="btn-import"
              onClick={() => {
                setButtonClicked("import");
                setShowMenu(true);
              }}
            >
              <i className="bi bi-upload"></i>Importer/Exporter un fichier
            </button>

            <button
              className="btn-manual"
              onClick={() => {
                setButtonClicked("manual");
                setShowMenu(true);
              }}
            >
              <i className="bi bi-pencil-square"></i>Saisie manuelle
            </button>
          </div>
        </div>

        {/* Filtres */}
        <div className="filters-bar">
          <div className="input-wrapper">
            <span className="search-icon">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              className="search-input"
              placeholder="Rechercher..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>

          <select className="custom-select" onChange={(e) => setStatutFilter(e.target.value)}>
            <option value="">Tous les statuts</option>
            <option value="en attente">En attente</option>
            <option value="retour">Retour à corriger</option>
            <option value="valide">Validé</option>
          </select>

          <select className="custom-select" onChange={(e) => setDomaineFilter(e.target.value)}>
            <option value="">Tous les domaines</option>
            <option value="AGRICULTURE">AGRICULTURE</option>
            <option value="PÊCHE & AQUACULTURE">PÊCHE & AQUACULTURE</option>
            <option value="ÉLEVAGE">ÉLEVAGE</option>
          </select>
        </div>

        {/* Menu pop-up */}
            {showMenu && (
              <AddDocumentMenuWrapper
                onSelect={handleSelectDomain}
                onCreateForm={handleCreateForm}
                onCreateIndicator={handleCreateIndicator}
                onCreateRapport={handleCreateRapport}   
                onClose={() => setShowMenu(false)}
                action={buttonClicked}
              />
            )}

        {/* Chargement */}
        {loading && <CollecteLoadingMessage message="Chargement des données..." />}

        {/* Tableau */}
        <div className="table-responsive shadow-sm">
          <table className="table table-hover align-middle">
            <thead className="table-success">
              <tr>
                <th>Domaine</th>
                <th>Contenu</th>
                <th>Date de soumission</th>
                <th>Statut</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {pageData.map((doc) => (
                <tr key={doc.id}>
                  <td>
                    <div className="fw-semibold">{doc.domaine}</div>
                  </td>

                  <td>{doc.contenu}</td>
                  <td>{doc.date}</td>

                  <td><StatusBadge statut={doc.statut} /></td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-success"
                      title="Voir les données"
                      onClick={async () => {
                        try {
                          // Appel backend pour récupérer les données du groupe import
                          const datas = await GroupeImportService.getDatasForGroupImport(api, doc.id);

                          // Met à jour le state pour le popup
                          setPopupData(datas);
                          setShowPopup(true);
                        } catch (error) {
                          console.error(
                            `Erreur lors de la récupération des données du groupe import ${doc.id}:`,
                            error
                          );
                        }
                      }}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showPopup && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              background: "rgba(0,0,0,0.5)",
              zIndex: 1050,
            }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                minHeight: "100vh",
                padding: "1rem",
              }}
            >
              <div
                className="modal-content"
                style={{
                  width: "95%",
                  maxWidth: "1400px",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  borderRadius: "0.5rem",
                }}
              >
                <div className="modal-header">
                  <h5 className="modal-title">Données du document</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowPopup(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {popupData.length === 0 ? (
                    <p>Aucune donnée disponible</p>
                  ) : (
                    <DynamicTable data={popupData}/>
                  )}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPopup(false)}
                  >
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}


        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
          <small className="text-muted">
            {pageData.length} documents affichés sur {total}
          </small>

          <nav>
            <ul className="pagination pagination-sm mb-0">
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setPage(page - 1)}>
                  <i className="bi bi-chevron-left"></i>
                </button>
              </li>

              {pageNumbers.map((num) => (
                <li key={num} className={`page-item ${num === currentPage ? "active" : ""}`}>
                  <button className="page-link" onClick={() => setPage(num)}>
                    {num}
                  </button>
                </li>
              ))}

              <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => setPage(page + 1)}>
                  <i className="bi bi-chevron-right"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </main>
    </AuthentifiedPage>
  );
};

export default DocumentListeAgentPage;
